import PropTypes from 'prop-types';
import React from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';
import './LoginFormGroup.css';

const isError = error => (error ? 'error' : null);

const LoginFormGroup = ({ meta, input, ...props }) => (
  <FormGroup className="loginFormControl" validationState={isError(meta.error)} >
    <FormControl {...input} {...props} bsSize="large" />
    <FormControl.Feedback />
  </FormGroup>
);

LoginFormGroup.defaultProps = {
  meta: {},
  input: {},
};

LoginFormGroup.propTypes = {
  meta: PropTypes.shape({}),
  input: PropTypes.shape({}),
};

export default LoginFormGroup;



// WEBPACK FOOTER //
// ./src/components/Login/LoginFormGroup/LoginFormGroup.jsx